import { AutogenLayoutStatusErrorQuickInfo } from "./autogen/AutogenLayoutStatusErrorQuickInfo";

export class StatusErrorQuickInfo extends AutogenLayoutStatusErrorQuickInfo {

}
